module.exports = __webpack_public_path__ + "img/success.a20e19de.svg";